import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSetupAuditTrailSlice } from './get';

import { coreDataSecurityAuditTrailExportReducers, coreDataSecurityAuditTrailExportWatchers } from './export';
import { coreDataSecuritySetupAuditTrailGraphReducers, coreDataSecuritySetupAuditTrailGraphWatchers } from './graph';
import { coreSetupAuditTrailSectionsReducers, coreSetupAuditTrailSectionsWatchers } from './sections';
import {
	coreSetupAuditTrailSourceNamePrefixReducers,
	coreSetupAuditTrailSourceNamePrefixWatchers
} from './source-name-prefix';

export const coreDataSecuritySetupAuditTrailReducers = combineReducers({
	export: coreDataSecurityAuditTrailExportReducers,
	get: getCoreSetupAuditTrailSlice.asyncReducers,
	graph: coreDataSecuritySetupAuditTrailGraphReducers,
	sections: coreSetupAuditTrailSectionsReducers,
	sourceNamePrefix: coreSetupAuditTrailSourceNamePrefixReducers
});

export const coreDataSecuritySetupAuditTrailWatchers = combineAllWatchers([
	coreDataSecurityAuditTrailExportWatchers,
	coreDataSecuritySetupAuditTrailGraphWatchers,
	coreSetupAuditTrailSectionsWatchers,
	coreSetupAuditTrailSourceNamePrefixWatchers,
	getCoreSetupAuditTrailSlice.asyncWatchers
]);
